import React from "react";
import {
  List,
  ListItem,
  ListItemText,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  createTheme,
  ThemeProvider,
} from "@mui/material";

import { DeviceType } from "../types/types";
import useWindowDimensions from "../hooks/useWindowDimensions";
import useTheme from "../hooks/useTheme";

export default function SupportedDevices(props: {
  devices: DeviceType[];
  style?: React.CSSProperties;
}) {
  const { isSmallLayout, isMediumLayout } = useWindowDimensions();
  const theme = useTheme();

  const muiTheme = createTheme({
    typography: {
      fontFamily: ["WixMadeforText"].join(","),
    },
  });

  function arrayToList(array: string[]) {
    return (
      <List
        dense={true}
        sx={{
          listStyleType: "disc",
          pl: 2,
          "& .MuiListItem-root": {
            display: "list-item",
          },
        }}
      >
        {array.map((item: string) => {
          return (
            <ListItem key={item}>
              <ListItemText primary={item} />
            </ListItem>
          );
        })}
      </List>
    );
  }

  function arrayToText(array: string[]) {
    let retStr: string = "";
    let first: boolean = true;

    array.forEach((item: string) => {
      if (first) {
        retStr += item;
        first = false;
      } else {
        retStr += " " + item;
      }
    });

    return retStr;
  }

  const styles: {
    header: React.CSSProperties;
    item: React.CSSProperties;
  } = {
    header: {
      fontWeight: "bold",
      color: theme.textColor,
    },
    item: { color: theme.textColor },
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        marginTop: 10,
        ...props.style,
      }}
    >
      <ThemeProvider theme={muiTheme}>
        <TableContainer
          component={Paper}
          sx={{ border: 1, borderColor: theme.detail }}
          style={{
            padding: 5,
            maxWidth: isSmallLayout || isMediumLayout ? "100%" : "80%",
            backgroundColor: theme.background,
            //borderColor: theme.detail,
            //borderWidth: 0.2,
          }}
        >
          <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
            <TableHead>
              <TableRow>
                <TableCell align="left" style={styles.header}>
                  Brand
                </TableCell>
                <TableCell align="left" style={styles.header}>
                  Models
                </TableCell>
                <TableCell align="left" style={styles.header}>
                  Installation notes
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {props.devices.map((item: DeviceType) => (
                <TableRow
                  key={item.brand}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell align="left" style={styles.item}>
                    {item.brand}
                  </TableCell>
                  <TableCell align="left" style={styles.item}>
                    {arrayToList(item.models)}
                  </TableCell>
                  <TableCell
                    align="left"
                    sx={{ maxWidth: 400 }}
                    style={styles.item}
                  >
                    {arrayToText(item.installationNotes)}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </ThemeProvider>
    </div>
  );
}
